module.exports = __webpack_public_path__ + "static/media/M1-18-Ariela-Baji-cod127-B.8a74a0fd.png";